import { FC } from "react";

import LazyLoadImage from "web/Layout/Common/LazyLoadImage";
import __ from "web/Layout/Translations";

import Anchor from "web/Components/Common/Anchor";

import { Nullable } from "web/types/Utils";

import classes from "./tile.scss";

interface ITileProps {
  img: string;
  href: string;
  closeAction: (index: Nullable<number>) => void;
  title: string;
}

const Tile: FC<ITileProps> = ({ img, href, closeAction, title }) => {
  return (
    <Anchor
      to={href}
      className={classes.root}
      onClick={closeAction as () => void}
      data-t1="main_menu_tile_link"
      data-testid="main_menu_tile_link"
      ariaLabel={`${__("Przejdź do strony")}: ${href}`}
    >
      <LazyLoadImage
        src={img}
        alt=""
        className={classes.image}
        width={314}
        height={210}
        dataGtm={title}
      />
    </Anchor>
  );
};

export default Tile;
